import { render, staticRenderFns } from "./SettingsOptionsGrid.vue?vue&type=template&id=3294c179&"
import script from "./SettingsOptionsGrid.vue?vue&type=script&lang=js&"
export * from "./SettingsOptionsGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports